(() => {
  const preferenceKey = 'haccp-price-display:v1';
  const root = document.documentElement;
  const setMode = (mode, persist = false) => {
    if (root.dataset.taxSwitchSupported !== 'true') return;
    const nextMode = mode === 'net' ? 'net' : 'gross';
    root.dataset.priceMode = nextMode;
    if (persist) {
      try { localStorage.setItem(preferenceKey, nextMode); } catch {}
    }
    document.dispatchEvent(new CustomEvent('haccp:price-mode', { detail: { mode: nextMode } }));
  };
  class HaccpTaxSwitch extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      this.addEventListener('click', this.onClick);
      document.addEventListener('haccp:price-mode', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('haccp:price-mode', this.sync);
    }
    onClick = (event) => {
      const button = event.target.closest('button[data-price-mode]');
      if (!button || !this.contains(button)) return;
      setMode(button.dataset.priceMode, true);
      const announcement = this.querySelector('[data-price-announcement]');
      announcement.textContent = button.textContent.trim();
    };
    sync = () => {
      this.querySelectorAll('button[data-price-mode]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.priceMode === root.dataset.priceMode));
      });
    };
  }
  if (!customElements.get('haccp-tax-switch')) customElements.define('haccp-tax-switch', HaccpTaxSwitch);
  window.addEventListener('storage', event => {
    if (event.key === preferenceKey) setMode(event.newValue);
  });
})();
